import * as addPanel from '@wix/editor-add-panel/sections/addPanel';

//@ts-expect-error
export const dataUtil: any = addPanel.dataUtil;
//@ts-expect-error
export const sections: any = addPanel.sections;

export default { dataUtil, sections };
